// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .paylixecommerce-cookie-container {
  background: var(--black0);
}

.paylixecommerce-cookie {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
@media (max-width: 768px) {
  .paylixecommerce-cookie {
    flex-direction: column;
  }
}
.paylixecommerce-cookie-overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(2px);
  top: 0;
  z-index: 9999999900;
}
.paylixecommerce-cookie-footer {
  gap: 1rem;
}
@media (max-width: 768px) {
  .paylixecommerce-cookie-footer {
    width: 100%;
    padding-top: 1rem;
    padding-left: 0 !important;
  }
  .paylixecommerce-cookie-footer div {
    width: 100%;
  }
  .paylixecommerce-cookie-footer div > button {
    width: 50%;
  }
}
.paylixecommerce-cookie button {
  cursor: pointer;
}
.paylixecommerce-cookie-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: var(--black9);
  margin-bottom: 0.5rem;
}
.paylixecommerce-cookie-header img {
  max-width: 20px;
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
}
.paylixecommerce-cookie-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1rem;
}
.paylixecommerce-cookie-footer button {
  white-space: nowrap;
}
.paylixecommerce-cookie-container {
  position: fixed;
  bottom: 1rem;
  right: 50%;
  width: calc(100% - 2rem);
  max-width: 1440px;
  background: var(--white);
  z-index: 999999999;
  border-radius: 0.5rem;
  box-shadow: 0px 2px 4px rgba(7, 14, 35, 0.08), 0px 2px 24px rgba(7, 14, 35, 0.12);
  padding: 1.25rem;
  transform: translateX(50%);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: var(--black6);
}
@media (max-width: 768px) {
  .paylixecommerce-cookie-container {
    font-size: 14px;
    line-height: 20px;
  }
}
.paylixecommerce-cookie-container.is-shop {
  background: var(--lightColor);
  color: var(--darkFontColor);
}
.paylixecommerce-cookie-container.is-shop .paylixecommerce-cookie-header {
  color: var(--lightFontColor);
}
.paylixecommerce-cookie-container.is-shop .paylixecommerce-cookie button.primary {
  background: var(--buttonColor);
  color: white !important;
}
.paylixecommerce-cookie-container.is-shop .paylixecommerce-cookie button.secondary {
  background: transparent;
  color: var(--lightFontColor);
}
@media (max-width: 768px) {
  .paylixecommerce-cookie-container {
    width: calc(100% - 2rem);
    right: 1rem;
    transform: none;
  }
}

div.paylixecommerce-cookie-modal-title {
  border-top: 1px solid var(--black2);
  margin-top: 1.5rem;
  padding-top: 1.5rem;
}

div.paylixecommerce-cookie-modal-collapsed-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0 1rem;
}
div.paylixecommerce-cookie-modal-collapsed-container > div {
  width: calc(50% - 1rem);
  margin-top: 0;
}

.paylixecommerce-cookie-overlay.paylixecommerce-overlay {
  z-index: 999999999;
}

html.dark .paylixecommerce-cookie-container, html.dark .paylixecommerce-cookie-modal {
  --black3: #A2AAB4;
  --black4: #777F89;
  --black6: #454C56;
  --black7: #A2AAB4;
  --black2: #262A30;
  --black9: white;
  --black5: #777F89;
  --black0: #121417;
  --white: #1B1F23;
  --black1: #262A30;
  --purple0: #43248e57;
  --purple1: #43248e57;
  --red0: #381E1D;
  --orange0: #35241E;
  --green0: #143120;
}

html .paylixecommerce-cookie-container, html .paylixecommerce-cookie-modal {
  --black9: #121417;
  --black8: #1B1F23;
  --black7: #262A30;
  --black6: #454C56;
  --black5: #555D67;
  --black4: #777F89;
  --black3: #A2AAB4;
  --black2: #DFE5E9;
  --black1: #E8EDF0;
  --black0: #F5F7F8;
  --white: white;
  --purple9: #43248E;
  --purple8: #5129AE;
  --purple7: #6132cf;
  --purple6: #6a3ce2;
  --purple5: #8164ee;
  --purple4: #a191f4;
  --purple3: #c0b9f9;
  --purple2: #dbd8fc;
  --purple1: #eceafd;
  --purple0: #f4f4fe;
  --red9: #381E1D;
  --red8: #60211F;
  --red7: #A53E3E;
  --red6: #D24242;
  --red5: #E85757;
  --red4: #f87171;
  --red3: #fca5a5;
  --red2: #fecaca;
  --red1: #fee2e2;
  --red0: #fef2f2;
  --orange9: #35241E;
  --orange8: #753621;
  --orange7: #BC542A;
  --orange6: #E16727;
  --orange5: #F17C2A;
  --orange4: #F69546;
  --orange3: #FCB871;
  --orange2: #fed7aa;
  --orange1: #F9ECDB;
  --orange0: #fff7ed;
  --green9: #143120;
  --green8: #166534;
  --green7: #15803d;
  --green6: #239F51;
  --green5: #35C068;
  --green4: #66DB91;
  --green3: #8CEDAF;
  --green2: #bbf7d0;
  --green1: #E3F5E9;
  --green0: #f0fdf4;
}

.paylixecommerce-cookie-modal {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: var(--black6);
  max-width: 800px !important;
}
.paylixecommerce-cookie-modal .paylixecommerce-modal-close {
  display: none;
}
.paylixecommerce-cookie-modal.is-shop.paylixecommerce-modal {
  background: var(--darkColor) !important;
  border: 1px solid var(--gridLine) !important;
}
.paylixecommerce-cookie-modal.is-shop.paylixecommerce-modal .paylixecommerce-modal-header {
  color: var(--lightFontColor) !important;
  border-bottom: 1px solid var(--gridLine) !important;
}
.paylixecommerce-cookie-modal.is-shop.paylixecommerce-modal .paylixecommerce-modal-footer {
  color: var(--lightFontColor) !important;
  border-bottom: 1px solid var(--gridLine) !important;
  border-top: 1px solid var(--gridLine);
}
.paylixecommerce-cookie-modal.is-shop.paylixecommerce-modal .paylixecommerce-modal-body {
  color: var(--darkFontColor);
}
.paylixecommerce-cookie-modal.is-shop.paylixecommerce-modal button.primary {
  background: var(--buttonColor);
  color: white !important;
}
.paylixecommerce-cookie-modal.is-shop.paylixecommerce-modal button.secondary {
  background: transparent;
  color: var(--lightFontColor);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-short-container > div {
  border: 1px solid var(--gridLine);
  background: var(--lightColor);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-title {
  color: var(--lightFontColor);
  border-top-color: var(--gridLine);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-label {
  color: var(--lightFontColor);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-more {
  border: 1px solid var(--gridLine);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-more .ReactCollapse--content > div {
  border-top: 1px solid var(--gridLine);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-more-title {
  color: var(--lightFontColor);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-details {
  background: var(--lightColor);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-details-title {
  color: var(--lightFontColor);
}
.paylixecommerce-cookie-modal.is-shop .paylixecommerce-cookie-modal-details-title + div {
  color: var(--darkFontColor);
}
.paylixecommerce-cookie-modal.paylixecommerce-modal {
  background: var(--white) !important;
  border: 1px solid var(--black1) !important;
}
.paylixecommerce-cookie-modal.paylixecommerce-modal .paylixecommerce-modal-header {
  color: var(--black9) !important;
  border-bottom: 1px solid var(--black1) !important;
}
.paylixecommerce-cookie-modal.paylixecommerce-modal .paylixecommerce-modal-footer {
  color: var(--black9) !important;
  border-bottom: 1px solid var(--black1) !important;
}
.paylixecommerce-cookie-modal.paylixecommerce-modal .paylixecommerce-modal-body {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: var(--black6);
}
.paylixecommerce-cookie-modal.paylixecommerce-modal button {
  cursor: pointer;
}
.paylixecommerce-cookie-modal .switcher {
  width: 2.75rem;
  min-width: 2.75rem;
  height: 1.5rem;
  margin: 0 0 0 1rem;
}
.paylixecommerce-cookie-modal .switcher-label {
  cursor: pointer;
  width: calc(100% - 3.75rem);
}
.paylixecommerce-cookie-modal .switcher-label .paylixecommerce-note {
  font-weight: 400;
  margin: 0;
}
.paylixecommerce-cookie-modal .switcher.left {
  margin-right: 0;
}
.paylixecommerce-cookie-modal .switcher-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.paylixecommerce-cookie-modal .switcher-container.withBorder {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--black1);
}
.paylixecommerce-cookie-modal .switcher-container.right .switcher {
  margin-left: 0;
}
.paylixecommerce-cookie-modal .switcher-container.right .switcher-label {
  width: calc(100% - 3rem);
}
.paylixecommerce-cookie-modal .switcher input {
  display: none;
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
  width: 50px;
}
.paylixecommerce-cookie-modal .switcher input:checked ~ .switcher-slider::before {
  transform: translateX(19px);
}
.paylixecommerce-cookie-modal .switcher input:checked + .switcher-slider {
  background-color: var(--purple6);
  border-color: var(--purple6);
}
.paylixecommerce-cookie-modal .switcher input:checked + .switcher-slider::before {
  border-color: var(--purple6);
}
.paylixecommerce-cookie-modal .switcher .switcher-slider {
  background-color: var(--black1);
  border: none;
  border-radius: 50em;
  font-size: 12px;
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  transition: 0.15s ease-out;
}
.paylixecommerce-cookie-modal .switcher .switcher-slider:before {
  width: 20px;
  height: 20px;
  top: 2px;
  border-radius: 100%;
  position: absolute;
  left: 2px;
  box-sizing: border-box;
  content: "";
  background-color: var(--white);
  border: 1px solid var(--black1);
  transition: 0.15s ease-out;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
}
.paylixecommerce-cookie-modal .switcher .switcher-slider span {
  border-radius: 50em;
  font-size: 12px;
  background-color: var(--black0);
  border: none;
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  transition: 0.15s ease-out;
}
.paylixecommerce-cookie-modal-short-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
}
.paylixecommerce-cookie-modal-short-container > div {
  border: 1px solid var(--black2);
  padding: 0 1.25rem 1.25rem 1.25rem;
  border-radius: 0.5rem;
  width: calc(50% - 1rem);
  margin-top: 0;
}
.paylixecommerce-cookie-modal-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: var(--black9);
  margin: 2rem 0 1rem 0;
}
.paylixecommerce-cookie-modal-label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: var(--black6);
  margin: 1rem 0;
}
.paylixecommerce-cookie-modal-more {
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  margin: 1rem 0 1rem 0;
  border: 1px solid var(--black2);
  border-radius: 0.5rem;
  cursor: pointer;
}
.paylixecommerce-cookie-modal-more ul {
  margin-bottom: 0;
}
.paylixecommerce-cookie-modal-more ul li {
  font-size: 14px;
  line-height: 21px;
}
.paylixecommerce-cookie-modal-more .ReactCollapse--content > div {
  padding: 1rem 0;
  border-top: 1px solid var(--black2);
}
.paylixecommerce-cookie-modal-more-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: var(--black9);
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.paylixecommerce-cookie-modal-more-title.open {
  padding-bottom: 1rem;
}
.paylixecommerce-cookie-modal-details {
  border-radius: 0.5rem;
  background: var(--black0);
  padding: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.paylixecommerce-cookie-modal-details .switcher-container {
  position: relative;
}
.paylixecommerce-cookie-modal-details .switcher-container-lock {
  display: flex;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.paylixecommerce-cookie-modal-details .switcher input:checked:disabled + .switcher-slider::before {
  width: 91%;
  transform: none;
  border-radius: 0.75rem;
}
.paylixecommerce-cookie-modal-details-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0.25rem;
  color: var(--black9);
}
.paylixecommerce-cookie-modal-details-title + div {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--black5);
  display: flex;
  cursor: pointer;
}
.paylixecommerce-cookie-modal-details-title + div svg {
  margin-left: 0.5rem;
  max-width: 15px !important;
  min-width: 15px !important;
}`, "",{"version":3,"sources":["webpack://./client/components/cookie/index.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAEF;AAAE;EALF;IAMI,sBAAA;EAGF;AACF;AADE;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,uCAAA;EACA,0BAAA;EACA,MAAA;EACA,mBAAA;AAGJ;AAAE;EACE,SAAA;AAEJ;AACI;EAJF;IAKI,WAAA;IACA,iBAAA;IACA,0BAAA;EAEJ;EAAI;IACE,WAAA;EAEN;EACI;IACE,UAAA;EACN;AACF;AAGE;EACE,eAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AAFJ;AAII;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAFN;AAME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,mBAAA;AAJN;AAQE;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iFAAA;EACA,gBAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AANJ;AAQI;EAnBF;IAoBI,eAAA;IACA,iBAAA;EALJ;AACF;AAOI;EACE,6BAAA;EACA,2BAAA;AALN;AAQQ;EACE,4BAAA;AANV;AASQ;EACE,8BAAA;EACA,uBAAA;AAPV;AAUQ;EACE,uBAAA;EACA,4BAAA;AARV;AAaI;EA7CF;IA8CI,wBAAA;IACA,WAAA;IACA,eAAA;EAVJ;AACF;;AAkBA;EACE,mCAAA;EACA,kBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AAfF;AAiBE;EACE,uBAAA;EACA,aAAA;AAfJ;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,oBAAA;EACA,oBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,iBAAA;AArBF;;AAwBA;EAEE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AA1BF;;AA8BA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;AA3BF;AA6BE;EACE,aAAA;AA3BJ;AA+BI;EACE,uCAAA;EACA,4CAAA;AA7BN;AA+BM;EACE,uCAAA;EACA,mDAAA;AA7BR;AA+BM;EACE,uCAAA;EACA,mDAAA;EACA,qCAAA;AA7BR;AAgCM;EACE,2BAAA;AA9BR;AAiCM;EACE,8BAAA;EACA,uBAAA;AA/BR;AAkCM;EACE,uBAAA;EACA,4BAAA;AAhCR;AAoCM;EACE,iCAAA;EACA,6BAAA;AAlCR;AAsCI;EACE,4BAAA;EACA,iCAAA;AApCN;AAuCI;EACE,4BAAA;AArCN;AAwCI;EACE,iCAAA;AAtCN;AAwCM;EACE,qCAAA;AAtCR;AAyCM;EACE,4BAAA;AAvCR;AA2CI;EACE,6BAAA;AAzCN;AA2CM;EACE,4BAAA;AAzCR;AA2CQ;EACE,2BAAA;AAzCV;AA+CE;EACE,mCAAA;EACA,0CAAA;AA7CJ;AA+CI;EACE,+BAAA;EACA,iDAAA;AA7CN;AA+CI;EACE,+BAAA;EACA,iDAAA;AA7CN;AA+CI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA7CN;AAgDI;EACE,eAAA;AA9CN;AAqDE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAnDJ;AAqDI;EACE,eAAA;EACA,2BAAA;AAnDN;AAqDM;EACE,gBAAA;EACA,SAAA;AAnDR;AAuDI;EACE,eAAA;AArDN;AAwDI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAtDN;AAwDM;EACE,mBAAA;EACA,oBAAA;EACA,sCAAA;AAtDR;AA0DQ;EACE,cAAA;AAxDV;AA0DU;EACE,wBAAA;AAxDZ;AA8DI;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AA5DN;AA8DM;EACE,2BAAA;AA5DR;AA8DM;EACE,gCAAA;EACA,4BAAA;AA5DR;AA8DQ;EACE,4BAAA;AA5DV;AAiEI;EACE,+BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AA/DN;AAiEM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,0BAAA;EACA,2CAAA;AA/DR;AAkEM;EACE,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AAhER;AAqEE;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAnEJ;AAqEI;EACE,+BAAA;EACA,kCAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;AAnEN;AAuEE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AArEJ;AAwEE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AAtEJ;AAyEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,eAAA;AAvEJ;AAyEI;EACE,gBAAA;AAvEN;AAyEM;EACE,eAAA;EACA,iBAAA;AAvER;AA2EI;EACE,eAAA;EACA,mCAAA;AAzEN;AA4EI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA1EN;AA4EM;EACE,oBAAA;AA1ER;AA+EE;EACE,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AA7EJ;AA+EI;EACE,kBAAA;AA7EN;AAgFI;EACE,aAAA;EACA,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;AA9EN;AAiFI;EACE,UAAA;EACA,eAAA;EACA,sBAAA;AA/EN;AAkFI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AAhFN;AAkFM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;AAhFR;AAkFQ;EACE,mBAAA;EACA,0BAAA;EACA,0BAAA;AAhFV","sourcesContent":[".dark .paylixecommerce-cookie-container {\n  background: var(--black0);\n}\n.paylixecommerce-cookie {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n  &-overlay {\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    background: #000000b3;\n    backdrop-filter: blur(2px);\n    top: 0;\n    z-index: 9999999900;\n  }\n\n  &-footer {\n    gap: 1rem;\n\n\n    @media (max-width: 768px) {\n      width: 100%;\n      padding-top: 1rem;\n      padding-left: 0 !important;\n\n      div {\n        width: 100%;\n      }\n\n      div > button {\n        width: 50%;\n      }\n    }\n  }\n\n  button {\n    cursor: pointer;\n  }\n\n  &-header {\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    color: var(--black9);\n    margin-bottom: .5rem;\n\n    img {\n      max-width: 20px;\n      width: 20px;\n      height: 20px;\n      margin-right: .5rem;\n    }\n  }\n\n  &-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 1rem;\n\n    button {\n      white-space: nowrap;\n    }\n  }\n\n  &-container {\n    position: fixed;\n    bottom: 1rem;\n    right: 50%;\n    width: calc(100% - 2rem);\n    max-width: 1440px;\n    background: var(--white);\n    z-index: 999999999;\n    border-radius: 0.5rem;\n    box-shadow: 0px 2px 4px rgba(7, 14, 35, 0.08), 0px 2px 24px rgba(7, 14, 35, 0.12);\n    padding: 1.25rem;\n    transform: translateX(50%);\n    font-family: 'Inter', sans-serif;;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 22px;\n    color: var(--black6);\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n      line-height: 20px;\n    }\n\n    &.is-shop {\n      background: var(--lightColor);\n      color: var(--darkFontColor);\n\n      .paylixecommerce-cookie {\n        &-header {\n          color: var(--lightFontColor);\n        }\n\n        button.primary {\n          background: var(--buttonColor);\n          color: white !important;\n        }\n\n        button.secondary {\n          background: transparent;\n          color: var(--lightFontColor);\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: calc(100% - 2rem);\n      right: 1rem;\n      transform: none;\n    }\n  }\n\n}\n\n\n\n\ndiv.paylixecommerce-cookie-modal-title {\n  border-top: 1px solid var(--black2);\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n}\n\ndiv.paylixecommerce-cookie-modal-collapsed-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 0 1rem;\n\n  & > div {\n    width: calc(50% - 1rem);\n    margin-top: 0;\n  }\n}\n\n\n.paylixecommerce-cookie-overlay.paylixecommerce-overlay {\n  z-index: 999999999;\n}\n\nhtml.dark .paylixecommerce-cookie-container, html.dark .paylixecommerce-cookie-modal {\n  --black3: #A2AAB4;\n  --black4: #777F89;\n  --black6: #454C56;\n  --black7: #A2AAB4;\n  --black2: #262A30;\n  --black9: white;\n  --black5: #777F89;\n  --black0: #121417;\n  --white: #1B1F23;\n  --black1: #262A30;\n\n  --purple0: #43248e57;\n  --purple1: #43248e57;\n\n  --red0: #381E1D;\n\n  --orange0: #35241E;\n\n  --green0: #143120;\n}\n\nhtml .paylixecommerce-cookie-container, html .paylixecommerce-cookie-modal {\n\n  --black9: #121417;\n  --black8: #1B1F23;\n  --black7: #262A30;\n  --black6: #454C56;\n  --black5: #555D67;\n  --black4: #777F89;\n  --black3: #A2AAB4;\n  --black2: #DFE5E9;\n  --black1: #E8EDF0;\n  --black0: #F5F7F8;\n  --white: white;\n\n  --purple9: #43248E;\n  --purple8: #5129AE;\n  --purple7: #6132cf;\n  --purple6: #6a3ce2;\n  --purple5: #8164ee;\n  --purple4: #a191f4;\n  --purple3: #c0b9f9;\n  --purple2: #dbd8fc;\n  --purple1: #eceafd;\n  --purple0: #f4f4fe;\n\n  --red9: #381E1D;\n  --red8: #60211F;\n  --red7: #A53E3E;\n  --red6: #D24242;\n  --red5: #E85757;\n  --red4: #f87171;\n  --red3: #fca5a5;\n  --red2: #fecaca;\n  --red1: #fee2e2;\n  --red0: #fef2f2;\n\n  --orange9: #35241E;\n  --orange8: #753621;\n  --orange7: #BC542A;\n  --orange6: #E16727;\n  --orange5: #F17C2A;\n  --orange4: #F69546;\n  --orange3: #FCB871;\n  --orange2: #fed7aa;\n  --orange1: #F9ECDB;\n  --orange0: #fff7ed;\n\n  --green9: #143120;\n  --green8: #166534;\n  --green7: #15803d;\n  --green6: #239F51;\n  --green5: #35C068;\n  --green4: #66DB91;\n  --green3: #8CEDAF;\n  --green2: #bbf7d0;\n  --green1: #E3F5E9;\n  --green0: #f0fdf4;\n\n}\n\n.paylixecommerce-cookie-modal {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--black6);\n  max-width: 800px !important;\n\n  .paylixecommerce-modal-close {\n    display: none;\n  }\n\n  &.is-shop {\n    &.paylixecommerce-modal {\n      background: var(--darkColor) !important;\n      border: 1px solid var(--gridLine) !important;\n\n      .paylixecommerce-modal-header {\n        color: var(--lightFontColor) !important;\n        border-bottom: 1px solid var(--gridLine) !important;\n      }\n      .paylixecommerce-modal-footer {\n        color: var(--lightFontColor) !important;\n        border-bottom: 1px solid var(--gridLine) !important;\n        border-top: 1px solid var(--gridLine);\n      }\n\n      .paylixecommerce-modal-body {\n        color: var(--darkFontColor);\n      }\n\n      button.primary {\n        background: var(--buttonColor);\n        color: white !important;\n      }\n\n      button.secondary {\n        background: transparent;\n        color: var(--lightFontColor);\n      }\n    }\n    .paylixecommerce-cookie-modal-short-container {\n      & > div {\n        border: 1px solid var(--gridLine);\n        background: var(--lightColor);\n      }\n    }\n\n    .paylixecommerce-cookie-modal-title {\n      color: var(--lightFontColor);\n      border-top-color: var(--gridLine);\n    }\n\n    .paylixecommerce-cookie-modal-label {\n      color: var(--lightFontColor);\n    }\n\n    .paylixecommerce-cookie-modal-more {\n      border: 1px solid var(--gridLine);\n\n      .ReactCollapse--content > div {\n        border-top: 1px solid var(--gridLine);\n      }\n\n      &-title {\n        color: var(--lightFontColor);\n      }\n    }\n\n    .paylixecommerce-cookie-modal-details {\n      background: var(--lightColor);\n\n      &-title {\n        color: var(--lightFontColor);\n\n        & + div {\n          color: var(--darkFontColor);\n        }\n      }\n    }\n  }\n\n  &.paylixecommerce-modal {\n    background: var(--white) !important;\n    border: 1px solid var(--black1) !important;\n\n    .paylixecommerce-modal-header {\n      color: var(--black9) !important;\n      border-bottom: 1px solid var(--black1) !important;\n    }\n    .paylixecommerce-modal-footer {\n      color: var(--black9) !important;\n      border-bottom: 1px solid var(--black1) !important;\n    }\n    .paylixecommerce-modal-body {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 20px;\n      color: var(--black6);\n    }\n\n    button {\n      cursor: pointer;\n    }\n\n  }\n\n\n\n  .switcher {\n    width: 2.75rem;\n    min-width: 2.75rem;\n    height: 1.5rem;\n    margin: 0 0 0 1rem;\n\n    &-label {\n      cursor: pointer;\n      width: calc(100% - 3.75rem);\n\n      .paylixecommerce-note {\n        font-weight: 400;\n        margin: 0;\n      }\n    }\n\n    &.left {\n      margin-right: 0;\n    }\n\n    &-container {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      flex-wrap: wrap;\n      width: 100%;\n\n      &.withBorder {\n        margin-bottom: 1rem;\n        padding-bottom: 1rem;\n        border-bottom: 1px solid var(--black1);\n      }\n\n      &.right {\n        .switcher {\n          margin-left: 0;\n\n          &-label {\n            width: calc(100% - 3rem);\n          }\n        }\n      }\n    }\n\n    input {\n      display: none;\n      position: absolute;\n      margin-top: 0.3rem;\n      margin-left: -1.25rem;\n      width: 50px;\n\n      &:checked ~ .switcher-slider::before {\n        transform: translateX(19px);\n      }\n      &:checked + .switcher-slider {\n        background-color: var(--purple6);\n        border-color: var(--purple6);\n\n        &::before {\n          border-color: var(--purple6);\n        }\n      }\n    }\n\n    .switcher-slider {\n      background-color: var(--black1);\n      border: none;\n      border-radius: 50em;\n      font-size: 12px;\n      position: relative;\n      display: block;\n      height: inherit;\n      cursor: pointer;\n      transition: .15s ease-out;\n\n      &:before {\n        width: 20px;\n        height: 20px;\n        top: 2px;\n        border-radius: 100%;\n        position: absolute;\n        left: 2px;\n        box-sizing: border-box;\n        content: \"\";\n        background-color: var(--white);\n        border: 1px solid var(--black1);\n        transition: .15s ease-out;\n        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);\n      }\n\n      span {\n        border-radius: 50em;\n        font-size: 12px;\n        background-color: var(--black0);\n        border: none;\n        position: relative;\n        display: block;\n        height: inherit;\n        cursor: pointer;\n        transition: .15s ease-out;\n      }\n    }\n  }\n\n  &-short-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem 2rem;\n\n    & > div {\n      border: 1px solid var(--black2);\n      padding: 0 1.25rem 1.25rem 1.25rem;\n      border-radius: 0.5rem;\n      width: calc(50% - 1rem);\n      margin-top: 0;\n    }\n  }\n\n  &-title {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--black9);\n    margin: 2rem 0 1rem 0;\n  }\n\n  &-label {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 17px;\n    color: var(--black6);\n    margin: 1rem 0;\n  }\n\n  &-more {\n    display: flex;\n    flex-direction: column;\n    padding: 0 1rem;\n    margin: 1rem 0 1rem 0;\n    border: 1px solid var(--black2);\n    border-radius: .5rem;\n    cursor: pointer;\n\n    ul {\n      margin-bottom: 0;\n\n      li {\n        font-size: 14px;\n        line-height: 21px;\n      }\n    }\n\n    .ReactCollapse--content > div {\n      padding: 1rem 0;\n      border-top: 1px solid var(--black2);\n    }\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 13px;\n      line-height: 17px;\n      color: var(--black9);\n      padding: 1rem 0;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      &.open {\n        padding-bottom: 1rem;\n      }\n    }\n  }\n\n  &-details {\n    border-radius: 0.5rem;\n    background: var(--black0);\n    padding: 1.25rem;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n\n    .switcher-container {\n      position: relative;\n    }\n\n    .switcher-container-lock {\n      display: flex;\n      position: absolute;\n      transform: translate(-50%, -50%);\n      top: 50%;\n      left: 50%;\n    }\n\n    .switcher input:checked:disabled + .switcher-slider::before {\n      width: 91%;\n      transform: none;\n      border-radius: 0.75rem;\n    }\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 20px;\n      margin-bottom: .25rem;\n      color: var(--black9);\n\n      & + div {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 18px;\n        color: var(--black5);\n        display: flex;\n        cursor: pointer ;\n\n        svg {\n          margin-left: .5rem;\n          max-width: 15px !important;\n          min-width: 15px !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
